import { getResolvedUserType } from "utils/MyMUtils";
import { isManagerUser } from "utils/navUtils";

// Managers see the dashboard for their own facilities only: the dashboard
// APIs take their user id as manager_id and count only the facilities they
// manage. Admins keep the whole-client dashboard (no extra parameter).
export const isDashboardManager = () =>
  isManagerUser(parseInt(localStorage.getItem("is_super_admin") || "0") === 1, getResolvedUserType());

export const managerQuery = () =>
  isDashboardManager() ? `&manager_id=${encodeURIComponent(localStorage.getItem("user_id") || "0")}` : "";
